import React from 'react';
import poupancaImg from "../../images/poupanca.svg";

const ConfirmationStep = ({ montante, montanteProgramado, periodicidade, productName, selectedSerieName, isPrazoCerto, reapply, onToggleReapply, pageTextoReaplicar }) => {
    const temMontante = parseFloat(montante) > 0;
    const temEntregasProgramadas = parseFloat(montanteProgramado) > 0;
    const temPeriodicidade = periodicidade?.trim();

    const totalApagar =
        (temMontante ? parseFloat(montante) : 0) +
        (temEntregasProgramadas ? parseFloat(montanteProgramado) : 0);

    const formatCurrency = (valor) =>
        new Intl.NumberFormat("pt-PT", {
            style: "currency",
            currency: "EUR"
        }).format(parseFloat(valor || 0));

    return (
        <div className="confirmacao-detalhada">
            <div className="icone-lateral">
                <span className="icone-texto">Confirmar dados</span>
                <img src={poupancaImg} alt="Confirmacao" className="icone-grande" />
            </div>
            <div className="caixa-confirmacao">
                <div className="titulo-box">SUBSCRIÇÃO</div>
                <h2 className="titulo-modalidade">
                    {selectedSerieName?.trim() || productName}
                </h2>
                <hr />

                <div style={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr 1fr",
                    marginBottom: "16px",
                    gap: "20px"
                }}>
                    <div>
                        <div className="subtitulo">Montante inicial</div>
                        <div className="valor">
                            {formatCurrency(montante)}
                        </div>
                    </div>
                    {temEntregasProgramadas && (
                        <div>
                            <div className="subtitulo">Montante dos reforços periódicos</div>
                            <div className="valor">
                                {temEntregasProgramadas ? formatCurrency(montanteProgramado) : ""}
                            </div>
                        </div>
                    )}
                    {temEntregasProgramadas && (
                        <div>
                            <div className="subtitulo">Periodicidade dos reforços periódicos</div>
                            <div className="valor">
                                {temPeriodicidade || ""}
                            </div>
                        </div>
                    )}
                </div>
                <div style={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr 1fr",
                    gap: "20px"
                }}>
                    <div>
                        <div className="subtitulo">Método de pagamento</div>
                        <div className="valor">Débito Direto</div>
                    </div>
                    <div></div>
                    <div>
                        <div className="subtitulo">Total a Pagar</div>
                        <div className="valor" style={{ fontWeight: "bold" }}>
                            {formatCurrency(totalApagar)}
                        </div>
                    </div>
                </div>
                {isPrazoCerto && (
                    <div className="reapply-toggle-container">
                        <div className="toggle-title">
                            {pageTextoReaplicar && pageTextoReaplicar.trim()
                                ? pageTextoReaplicar
                                : "Reaplicar capital recebido no final do prazo"}
                        </div>

                        <label className="toggle-wrapper">
                            <input
                                type="checkbox"
                                className="toggle-input"
                                checked={!!reapply}
                                onChange={(e) => {

                                    onToggleReapply && onToggleReapply();
                                }}
                                aria-label="Reaplicar capital"
                            />
                            <span className="toggle-slider" />
                        </label>
                    </div>
                )}

            </div>
        </div>
    );
};

export default ConfirmationStep;
